<div class="main" [class.assign-dialog-mode]="isDialogMode">
    <div class="container-fluid">
        <!-- Header Section -->
        <div class="tenders-header d-flex flex-wrap justify-content-between align-items-center m-4" *ngIf="!isDialogMode">
            <div class="tenders-title-container mb-3 mb-md-0">
                <button class="btn back-btn p-0 mb-2 d-flex align-items-center" (click)="goBack()" aria-label="Go back to Evaluations">
                    <i class="fas fa-arrow-left me-2"></i>
                    Go back to Evaluations
                </button>
                <h3>Assign Evaluators</h3>
                <span>
                    <a [routerLink]="['/' + AppConstants.ROUTES.HOME]" class="tenders-header-title breadcrumb-link">Dashboard <i class="lni lni-chevron-right" aria-hidden="true"></i></a>
                    <a [routerLink]="['/' + AppConstants.ROUTES.EVALUATIONS]" class="tenders-header-title breadcrumb-link">Evaluations <i class="lni lni-chevron-right" aria-hidden="true"></i></a>
                    <span>Assign Evaluators</span>
                </span>
            </div>
        </div>

        <div class="assign-dialog-header" *ngIf="isDialogMode">
            <h3>Assign Evaluators</h3>
            <button type="button" class="dialog-close-btn" (click)="onCancel()" aria-label="Close">
                <i class="fas fa-times"></i>
            </button>
        </div>

        <!-- Form Section -->
        <div class="mandatory-application m-4" [class.m-0]="isDialogMode">
            <div class="inside-out p-4">
                <div class="mandatory-fields"></div>
                <form [formGroup]="assignForm" (ngSubmit)="onAssign()">
                    <div class="container pt-4">
                        <div class="mandatory-line">
                            <span class="mandatory-par">
                                Mandatory fields below are marked with <span style="color: red;font-size: 1rem;">*</span>
                            </span>
                        </div>
                        <br>

                        <!-- Basic Information Section -->
                        <h4 class="fw-bold mb-4">Basic Information</h4>

                        <!-- PRs and Evaluation Type -->
                        <div class="row mb-4">
                            <div class="col-12 col-md-6 mb-3 mb-md-0">
                                <label for="pr" class="form-label fw-bold">
                                    PRs <span style="color: red;font-size: 1rem;">*</span>
                                </label>
                                <select
                                    id="pr"
                                    class="form-control rounded-4 bg-light p-2"
                                    formControlName="pr"
                                    [disabled]="isPrDisabled"
                                    [class.is-invalid]="assignForm.get('pr')?.invalid && assignForm.get('pr')?.touched">
                                    <option value="">Select PR</option>
                                    <option *ngFor="let option of prOptions" [value]="option.value">
                                        {{ option.label }}
                                    </option>
                                </select>
                                <div class="text-danger" *ngIf="assignForm.get('pr')?.invalid && assignForm.get('pr')?.touched">
                                    This field is required
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <label for="evaluationType" class="form-label fw-bold">
                                    Evaluation Type <span style="color: red;font-size: 1rem;">*</span>
                                </label>
                                <select
                                    id="evaluationType"
                                    class="form-control rounded-4 bg-light p-2"
                                    formControlName="evaluationType"
                                    [disabled]="isEvaluationTypeDisabled"
                                    [class.is-invalid]="assignForm.get('evaluationType')?.invalid && assignForm.get('evaluationType')?.touched">
                                    <option value="">Select Evaluation Type</option>
                                    <option *ngFor="let option of evaluationTypeOptions" [value]="option.value">
                                        {{ option.label }}
                                    </option>
                                </select>
                                <div class="text-danger" *ngIf="assignForm.get('evaluationType')?.invalid && assignForm.get('evaluationType')?.touched">
                                    This field is required
                                </div>
                            </div>
                        </div>

                        <!-- Assignment Section -->
                        <h4 class="fw-bold mb-4 mt-5">Assignment</h4>
                        <p class="text-muted mb-3">Select Evaluator(s)</p>

                        <!-- Search Bar -->
                        <div class="row mb-4">
                            <div class="col-12">
                                <div class="search-container position-relative">
                                    <i class="fa fa-search-icon">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M11 20C15.9706 20 20 15.9706 20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20Z"
                                                stroke="#767676" stroke-width="1.5" stroke-linecap="round"
                                                stroke-linejoin="round"></path>
                                            <path d="M18.9304 20.6898C19.4604 22.2898 20.6704 22.4498 21.6004 21.0498C22.4504 19.7698 21.8904 18.7198 20.3504 18.7198C19.2104 18.7098 18.5704 19.5998 18.9304 20.6898Z"
                                                stroke="#767676" stroke-width="1.5" stroke-linecap="round"
                                                stroke-linejoin="round"></path>
                                        </svg>
                                    </i>
                                    <label for="evaluator-search" class="sr-only">Search evaluators</label>
                                    <input
                                        type="text"
                                        id="evaluator-search"
                                        class="form-control rounded-4 bg-light search-input"
                                        placeholder="Search"
                                        [(ngModel)]="searchTerm"
                                        [ngModelOptions]="{standalone: true}"
                                        (ngModelChange)="onSearchChange()"
                                        aria-label="Search evaluators">
                                </div>
                            </div>
                        </div>

                        <!-- Evaluator List -->
                        <div class="row mb-4">
                            <div class="col-12">
                                <div class="evaluator-list-container">
                                    <div
                                        *ngFor="let evaluator of filteredEvaluators"
                                        class="evaluator-item"
                                        [class.selected]="isEvaluatorSelected(evaluator.id)"
                                        (click)="toggleEvaluatorSelection(evaluator.id)">
                                        <div class="evaluator-info">
                                            <div class="evaluator-name fw-bold">{{ evaluator.name }}</div>
                                            <div class="evaluator-role text-muted" *ngIf="evaluator.role">{{ evaluator.role }}</div>
                                        </div>
                                        <div class="selection-indicator" *ngIf="isEvaluatorSelected(evaluator.id)">
                                            <i class="fas fa-check-circle"></i>
                                        </div>
                                    </div>

                                    <div *ngIf="filteredEvaluators.length === 0" class="no-results text-center py-5">
                                        <p class="text-muted">No evaluators found matching your search.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Due Date Section -->
                        <div class="row mb-4">
                            <div class="col-12">
                                <label for="dueDate" class="form-label fw-bold">Due Date</label>
                                <input
                                    type="date"
                                    id="dueDate"
                                    class="form-control rounded-4 bg-light search-input"
                                    formControlName="dueDate">
                            </div>
                        </div>

                        <!-- Notes / Instructions Section -->
                        <div class="row mb-4">
                            <div class="col-12">
                                <label for="notes" class="form-label fw-bold">Notes / Instructions</label>
                                <textarea
                                    id="notes"
                                    class="form-control rounded-4 bg-light p-2"
                                    formControlName="notes"
                                    rows="5"
                                    placeholder="Enter any notes or instructions..."></textarea>
                            </div>
                        </div>
                    </div>

                    <!-- Footer Buttons -->
                    <div class="form-footer">
                        <button type="button" class="btn cancel-btn" (click)="onCancel()">Cancel</button>
                        <button type="button" class="btn save-draft-btn" (click)="onSaveDraft()">Save as Draft</button>
                        <button type="submit" class="btn assign-btn">Assign</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
